import React, {useState, useEffect} from "react";
import Header from "../include/header";
import Footer from "../include/footer";
import UserLeftPanel from "../include/UserLeftPanel";
import Global from "../../APIConfig";
import  axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AuthUser from "../../AuthUser";
import { useNavigate,useParams } from 'react-router-dom';
import MainLoader from "../Loaders/MainLoader";

function TransporterEdit(){
    let navigate = useNavigate();
    const {id} = useParams();
    const {headers1,headers2,logout}=AuthUser();
    const [Countrylist, setCountrylist] = useState([]);
    const [Citylist, setCitylist] = useState([]);
    const [Name, setName] = useState('');
    const [companyName, setCompanyName] = useState('');
    const [Phone, setPhone] = useState('');
    const [Email, setEmail] = useState('');
    const [Zip, setZip] = useState('');
    const [Country, setCountry] = useState('');
    const [City, setCity] = useState('');
    const [Address, setAddress] = useState('');
    const [Loading, setLoading] = useState(true);
    const [BtnLoading, setBtnLoading] = useState(false);
    const [serviceType, setServiceType] = useState('');
    const [vehicleType, setVehicleType] = useState('');
    const [ifscCode, setIfscCode] = useState('');
    const [bankName, setBankName] = useState('');
    const [bankAccountNumber, setBankAccountNumber] = useState('');
    const [panNumber, setPanNumber] = useState('');
    const [gstNumber, setGstNumber] = useState('');
    const [vehicleNo, setVehicleNo] = useState('');
    useEffect(()=>{
        GetStaffDetail(id);
        GetCountrylist();
    },[]);
    const GetStaffDetail=(id)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'GetTransporterDetail',
            headers:headers1,
            data: {
                id:id
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setName(data.name);
                setCompanyName(data.company_name);
                setAddress(data.address);
                setPhone(data.mobile);
                setZip(data.pincode);
                setEmail(data.email);
                setCity(data.city);
                setCountry(data.country);
                handleCountryChange(data.country);
                setServiceType(data.service_type);
                setVehicleType(data.vehicle_type);
                setIfscCode(data.ifsc_code);
                setBankName(data.bank_name);
                setBankAccountNumber(data.bank_account_number);
                setPanNumber(data.pan_number);
                setGstNumber(data.gst_number);
                setVehicleNo(data.vehicle_no);
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
          });
          setLoading(false);
    }
    const GetCountrylist=()=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Countrylist',
            data: {
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCountrylist(data);
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
          });
    }
    const GetCityList=(val)=>{
        axios({
            method: 'post',
            url: Global.baseUrl+'Citylist',
            data: {
                name: val
            }
          })
          .then(function (response) {
            if(response.data.status == 200)
            {
                var data=response.data.value;
                setCitylist(data);
            }
            else
            {
                setCitylist([]);
            }
          })
          .catch(function (error) {
            if(error.response.status==401){
                toast.error(error.response.statusText);
                logout();
                navigate('/');
                window.location.reload();
            }
          });
    }
    const handleCountryChange = (val) => {
        setCountry(val);
        GetCityList(val);
    };
    const handleCityChange = (val) => {
        setCity(val);
    };
    const handleSubmit=()=>{
        if(Name==""){
            toast.warning('Transporter Name is Required');
            return;
        }
        // if(companyName==""){
        //     toast.warning('Company Name is Required');
        //     return;
        // }
        if(Email==""){
            toast.warning('Email is Required');
            return;
        }
        if(Phone==""){
            toast.warning('Mobile No. is Required');
            return;
        }
        if(serviceType==""){
            toast.warning('Please Select service type');
            return;
        }
        if(vehicleType==""){
            toast.warning('Please Select vehicle type');
            return;
        }
        if(vehicleNo==""){
            toast.warning('Vehicle number is Required');
            return;
        }
            setBtnLoading(true);
            axios({
                method: 'post',
                url: Global.baseUrl+'EditTransporter',
                headers:headers2,
                data: {
                    id:id,
                    name:Name,
                    company_name:companyName,
                    email:Email,
                    mobile:Phone,
                    address:Address,
                    city:City,
                    country:Country,
                    pincode:Zip,
                    service_type:serviceType,
                    vehicle_type:vehicleType,
                    vehicle_no:vehicleNo,
                    gst_number:gstNumber,
                    pan_number:panNumber,
                    bank_account_number:bankAccountNumber,
                    bank_name:bankName,
                    ifsc_code:ifscCode
                }
              })
              .then(function (response) {
                if(response.data.status == 200)
                {
                    toast.success(response.data.message);
                }else{
                    toast.warning(response.data.message);
                }
                setBtnLoading(false);
              })
              .catch(function (error) {
                setBtnLoading(false);
                if(error.response.status==401){
                    toast.error(error.response.statusText);
                    logout();
                    navigate('/');
                    window.location.reload();
                }
              });
    }

    return(
        <>
            <UserLeftPanel/>
            <main className='home-section'>
                <Header/>
                <ToastContainer/>
                {Loading==true?<MainLoader/>:
                <>
                <section className="left_sub_menu">
                    <div className="row">
                        <div className="col-12 col-md">
                            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
                                <div className="d-block mb-4 mb-md-0">
                                    <nav aria-label="breadcrumb" className="d-none d-md-inline-block">
                                        <ol className="breadcrumb breadcrumb-dark breadcrumb-transparent">
                                            <li className="breadcrumb-item">
                                                <a href="/Admin-Dash">
                                                <i className="bx bx-home text-primary-400 fs-6"></i>
                                                </a>
                                            </li>
                                            <li className="breadcrumb-item active" aria-current="page">Edit Transporter</li>
                                        </ol>
                                    </nav>
                                    <div className="d-flex justify-content-between">
                                        <div className="">
                                            <button className="btn btn_nav btn-sm" type="button" onClick={() => navigate(-1)}>
                                            <i className="bx bx-arrow-back "></i>
                                            </button>
                                        </div>
                                        <div className="ps-2 ">
                                            <h2 className="h4">Edit Transporter</h2>
                                        </div>
                                    </div>
                                </div>
                                <div className="btn-toolbar mb-2 mb-md-0">
                                </div>
                            </div>

                            <div className="card">
                                <div className="card-body">
                                <h6>Edit Transporter</h6>
                                    <div className="row">
                                        <div className="col-12 mb-3 mt-4">
                                            <div className="row">
                                                <div className="col-4 mb-3">
                                                    <label htmlFor="" className="form-label">Transporter Name: <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control" value={Name} onChange={(e)=>setName(e.target.value)} placeholder="Please enter name" />
                                                </div>
                                                <div className="col-4 mb-3">
                                                  <label htmlFor="" className="form-label">Company Name: <span className="text-danger"></span></label>
                                                  <input type="text" className="form-control" value={companyName} onChange={(e)=>setCompanyName(e.target.value)} placeholder="Please enter company name" />
                                              </div>
                                                <div className="col-4 mb-3">
                                                    <label htmlFor="" className="form-label">Email: <span className="text-danger">*</span></label>
                                                    <input type="email" className="form-control" value={Email} onChange={(e)=>setEmail(e.target.value)} placeholder="Please enter email" />
                                                </div>
                                                <div className="col-4 mb-3">
                                                    <label htmlFor="" className="form-label">Mobile No.: <span className="text-danger">*</span></label>
                                                    <input type="number" className="form-control" value={Phone} onChange={(e)=>setPhone(e.target.value)} placeholder="Please enter mobile number" />
                                                </div>
                                                <div className="col-4 mb-3">
                                                <label className="form-label">Service Type <span className="text-danger">*</span></label>
                                                <select
                                                    className="form-select"
                                                    onChange={(e) => setServiceType(e.target.value)}
                                                >
                                                    <option value="">Select Service</option>
                                                    <option selected={"standard"==serviceType?true:false} value="standard">Standard</option>
                                                    <option selected={"express"==serviceType?true:false} value="express">Express</option>
                                                    <option selected={"overnight"==serviceType?true:false} value="overnight">Overnight</option>
                                                    <option selected={"international"==serviceType?true:false} value="international">International</option>
                                                </select>
                                                </div>
                                                <div className="col-4 mb-3">
                                                  <label className="form-label">Vehicle Type</label>
                                                  <select
                                                      className="form-select"
                                                      onChange={(e) => setVehicleType(e.target.value)}
                                                  >
                                                      <option value="">Select Vehicle</option>
                                                      <option selected={"bike"==vehicleType?true:false} value="bike">Bike</option>
                                                      <option selected={"car"==vehicleType?true:false} value="car">Car</option>
                                                      <option selected={"van"==vehicleType?true:false} value="van">Van</option>
                                                      <option selected={"truck"==vehicleType?true:false} value="truck">Truck</option>
                                                      <option selected={"tempo"==vehicleType?true:false} value="tempo">Tempo</option>
                                                  </select>
                                                </div>
                                                <div className="col-4 mb-3">
                                                    <label htmlFor="" className="form-label">Vehicle No: <span className="text-danger">*</span></label>
                                                    <input type="text" className="form-control" value={vehicleNo} onChange={(e)=>setVehicleNo(e.target.value)} placeholder="Please enter vehicle number" />
                                                </div>
                                                <div className="col-4 mb-3">
                                                    <div><label htmlFor="email" className="form-label">Country: <span className="text-danger"></span></label></div>
                                                    <select className="form-select" onChange={(e)=>handleCountryChange(e.target.value)}>
                                                        <option value="">-- Please Select --</option>
                                                        {Countrylist.map((list)=>{
                                                            return (
                                                                <option selected={list.country==Country?true:false} value={list.country}>{list.country}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-4 mb-3">
                                                    <div><label htmlFor="email" className="form-label">City: <span className="text-danger"></span></label></div>
                                                    <select className="form-select" onChange={(e)=>handleCityChange(e.target.value)}>
                                                        <option value="">-- Please Select --</option>
                                                        {Citylist.map((list)=>{
                                                            return (
                                                                <option selected={list.value==City?true:false} value={list.value}>{list.label}</option>
                                                            );
                                                        })}
                                                    </select>
                                                </div>
                                                <div className="col-4 mb-3">
                                                    <label htmlFor="" className="form-label">Postal Code: <span className="text-danger"></span></label>
                                                    <input type="text" className="form-control" value={Zip} onChange={(e)=>setZip(e.target.value)} placeholder="Please enter postal code" />
                                                </div>
                                                <div className="col-12 mb-3">
                                                    <label htmlFor="" className="form-label">Address: <span className="text-danger"></span></label>
                                                    <textarea className="form-control" value={Address} rows={5} onChange={(e)=>setAddress(e.target.value)} placeholder="Please enter transporter address" ></textarea>
                                                </div>
                                            <hr />
                                            {/* Business Details */}
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">GST Number: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={gstNumber} onChange={(e)=>setGstNumber(e.target.value)} placeholder="Please enter gst number" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">PAN Number: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={panNumber} onChange={(e)=>setPanNumber(e.target.value)} placeholder="Please enter pan number" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Bank Account Number: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={bankAccountNumber} onChange={(e)=>setBankAccountNumber(e.target.value)} placeholder="Please enter bank account number" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">Bank Name: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={bankName} onChange={(e)=>setBankName(e.target.value)} placeholder="Please enter bank name" />
                                            </div>
                                            <div className="col-4 mb-3">
                                                <label htmlFor="" className="form-label">IFSC Code: <span className="text-danger">*</span></label>
                                                <input type="text" className="form-control" value={ifscCode} onChange={(e)=>setIfscCode(e.target.value)} placeholder="Please enter ifsc code" />
                                            </div>
                                            </div>
                                        </div>
                                    </div>
                                    {BtnLoading==false?
                                    <div className="d-grid col-md-2 mt-2">
                                        <button className="btn btn-primary" onClick={()=>handleSubmit()}>Update Transporter</button>
                                    </div>
                                    :
                                    <div className="d-grid col-md-2 mt-2">
                                        <a href="" className="btn btn-primary btn-block"> <div className="spinner-border text-light" role="status"><span className="visually-hidden">Loading...</span></div></a>
                                    </div>
                                    }
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            </>
                }
                <Footer/>
            </main>
        </>
    )
}
export default TransporterEdit;